/* eslint-disable @typescript-eslint/no-explicit-any */
import { useMutation } from 'react-query';
import { message as antdMessage } from 'antd';
import { useTranslation } from 'react-i18next';
import { API } from 'api';

interface IDownloadOutletEmployees {
  payload: {
    outletId: string;
    eid: string;
  };
}

export const requestDownloadOutletEmployees = (payload: IDownloadOutletEmployees['payload']) =>
  API.get()(`/api/admin/outlets/employee`, { ...payload, page: 1, download: true });

export const useDownloadOutletEmployees = () => {
  const { t } = useTranslation();
  return useMutation(requestDownloadOutletEmployees, {
    onSuccess: () => {
      antdMessage.success(t('label.downloadRequestReceived'));
    },
    onError: (err: any) => {
      antdMessage.error(err?.response?.data?.message ?? t('label.downloadRequestFailed'));
    },
  });
};
